var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorTriangleOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "report_problem_black_24dp",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_305273",
    "data-name": "Path 305273",
    d: "M0,0H24V24H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_305274",
    "data-name": "Path 305274",
    d: "M12,5.99,19.53,19H4.47L12,5.99M12,2,1,21H23Zm1,14H11v2h2Zm0-6H11v4h2Z",
    fill: "#f4891e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorTriangleOrange);
export default __webpack_public_path__ + "static/media/error-triangle-orange.d2c651f7066802aec492416b27acf192.svg";
export { ForwardRef as ReactComponent };